const options = {
  5: "bg-blue-400/5",
  10: "bg-blue-400/10",
  25: "bg-blue-400/25",
  50: "bg-blue-400/50",
  75: "bg-blue-400/75",
  90: "bg-blue-400/90",
  100: "bg-blue-400",
};

const from = {
  5: "from-blue-400/5",
  10: "from-blue-400/10",
  25: "from-blue-400/25",
  50: "from-blue-400/50",
  75: "from-blue-400/75",
  90: "from-blue-400/90",
  100: "from-blue-400",
};

export default function getBackgroundBlue400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
